import { combineReducers } from "redux";
import data from './dataSlice'

const reducer = combineReducers({
    data
})

export default reducer